// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"478607e8","239":"40854584","453":"295221b6","455":"a61f1dbb"}[chunkId] + ".chunk.js";
};